import { Table, Tag } from "antd";
import { formatDateToYYYYMMDDHHMMSS, getShortDate } from "../../utils/Common";

const statusMap = {
  "0": "不在", "1": "興味なし", "3": "即断り", "4": "着信拒否",
  "5": "再アクション", "6": "面談アサイン", "7": "イベントアサイン",
  "8": "電話番号不備", "10": "追客中", "11": "サービス停止",
  "12": "サービス停止（メールOK）", "13": "前日確認OK",
  "14": "キャンセル", "15": "日程変更","16": "アポ獲得", "17": "担当断り", "18": "受付断り", "19": "仮押さえ", "20": "担当不在", "21": "再架電"
};

const StatusMemoTab = ({ statuses }) => {

const columns = [
{
    title: "ステータス",
    key: "status",
    dataIndex: "status",
    render: (val) => <Tag color="blue">{statusMap[String(val)] ?? val}</Tag>,
    width: 120,
    filters: [...new Set((statuses || []).map(item => item.status).filter(v => v !== null && v !== undefined))]
      .map(statusValue => ({
        text: statusMap[String(statusValue)] ?? statusValue,
        value: String(statusValue),
    })),
    onFilter: (value, record) => String(record.status) === value,
},
{
    title: "コメント",
    key: "comments",
    dataIndex: "comments",
    render: (val) => val || "-",
    width: 200,
},
{
    title: "架電先",
    key: "candidate_phone",
    dataIndex: "candidate_phone",
    width: 200,
},
{
    title: "架電者",
    key: "author",
    render: (_, record) => record.author?.name || "-",
    width: 150,
},
{
    title: "更新日時",
    dataIndex: "updated_at",
    key: "updated_at",
    render: (val) => val ? formatDateToYYYYMMDDHHMMSS(val) : "-",
    width: 150,
    sorter: (a, b) => new Date(a.updated_at) - new Date(b.updated_at),
},
];

  return (
    <Table
      dataSource={statuses}
      columns={columns}
      rowKey="id"
      size="small"
      pagination={false}
    />
  );
};

export default StatusMemoTab;